module.exports = __webpack_public_path__ + "assets/title-gradient.001cb6f9.svg";